module.exports = __webpack_public_path__ + "static/media/Other.ae12afdf.png";